import { combineReducers } from 'redux';
import activePanels from './managementPanels';
import subscription from './orSubscription';
import orders from './orOrders';
import cancelOrderData from './cancelOrderData';
import settings from './settings';
import suggestedOrder from './suggestedOrder';
import suggestedOrderNavigation from './suggestedOrderNavigation';

export default combineReducers({
  activePanels,
  subscription,
  orders,
  cancelOrderData,
  settings,
  suggestedOrder,
  suggestedOrderNavigation,
});
